package com.eladfinish.bible.contest.analytics

import androidx.compose.ui.text.intl.Locale
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.data.platform.CountryDetector
import com.eladfinish.bible.contest.features.verseWidget.UpdateVerseWidgetUserPropertyUseCase
import com.eladfinish.bible.contest.repository.analytics.FirebaseAnalyticsRepository
import com.russhwolf.settings.Settings

class SetUserPropertiesUseCase(
    private val settings: Settings,
    private val countryDetector: CountryDetector,
    private val firebaseAnalyticsRepository: FirebaseAnalyticsRepository,
    private val installationIdUserProperty: InstallationIdUserProperty,
    private val updateVerseWidgetUserProperty: UpdateVerseWidgetUserPropertyUseCase,
) {

    operator fun invoke() {
        val language = Locale.current.language
        firebaseAnalyticsRepository.setUserProperty("user_locale", language)
        val email = settings.getString(key = Constants.PREF_USER_EMAIL, defaultValue = "")
        email.takeIf { it.isNotEmpty() }.let {
            firebaseAnalyticsRepository.setUserProperty("user_email", it)
        }

        installationIdUserProperty()
        updateVerseWidgetUserProperty()

        mapOf(
            CustomKey.EMAIL to email,
            CustomKey.DEVICE_COUNTRY to countryDetector.getDetectedCountry().uppercase(),
            CustomKey.LOCALE to language,
        ).forEach { (key, value) ->
            firebaseAnalyticsRepository.setCrashlyticsCustomKey(key, value)
        }
    }

    companion object {
        private object CustomKey {
            const val EMAIL = "Email"
            const val DEVICE_COUNTRY = "Country (device)"
            const val LOCALE = "Locale"
        }
    }
}
